import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "wpdonation-box" }
const _hoisted_2 = {
  key: 0,
  class: "wpdonation-title"
}
const _hoisted_3 = { class: "easy-donation-box" }
const _hoisted_4 = { class: "single-credit-cardd" }
const _hoisted_5 = { class: "wpcm-row wpmc-justify-content-center" }
const _hoisted_6 = { class: "wpcm-col-md-6" }
const _hoisted_7 = { class: "textfield" }
const _hoisted_8 = ["placeholder", "disabled"]
const _hoisted_9 = { class: "wpcm-col-md-6" }
const _hoisted_10 = { class: "textfield" }
const _hoisted_11 = ["placeholder", "disabled"]
const _hoisted_12 = { class: "wpcm-col-md-12" }
const _hoisted_13 = { class: "textfield" }
const _hoisted_14 = ["placeholder", "readonly", "disabled"]
const _hoisted_15 = { class: "wpcm-col-md-12" }
const _hoisted_16 = { class: "textfield" }
const _hoisted_17 = ["placeholder", "disabled"]
const _hoisted_18 = {
  key: 0,
  class: "wpcm-col-md-12"
}
const _hoisted_19 = { class: "textfield" }
const _hoisted_20 = ["placeholder", "disabled"]
const _hoisted_21 = {
  key: 1,
  class: "wpcm-col-md-12"
}
const _hoisted_22 = { class: "textfield" }
const _hoisted_23 = {
  key: 2,
  class: "wpcm-col-md-12"
}
const _hoisted_24 = { class: "textfield" }
const _hoisted_25 = ["placeholder", "disabled"]
const _hoisted_26 = {
  key: 3,
  class: "wpcm-col-md-12"
}
const _hoisted_27 = { class: "textfield" }
const _hoisted_28 = ["placeholder", "disabled"]
const _hoisted_29 = {
  key: 4,
  class: "wpcm-col-md-12"
}
const _hoisted_30 = { class: "textfield" }
const _hoisted_31 = ["placeholder", "disabled"]
const _hoisted_32 = {
  key: 5,
  class: "wpcm-col-md-12"
}
const _hoisted_33 = { class: "textfield" }
const _hoisted_34 = ["placeholder", "disabled"]
const _hoisted_35 = {
  key: 6,
  class: "wpcm-col-md-12"
}
const _hoisted_36 = { class: "textfield" }
const _hoisted_37 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.strings)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString($props.strings.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: $setup.trans('first_name'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.billing_fields.first_name) = $event)),
                disabled: $setup.store.loading,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_8), [
                [_vModelText, $setup.store.billing_fields.first_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: $setup.trans('last_name'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.store.billing_fields.last_name) = $event)),
                disabled: $setup.store.loading,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_11), [
                [_vModelText, $setup.store.billing_fields.last_name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                placeholder: $setup.trans('email'),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.billing_fields.email) = $event)),
                readonly: $props.is_logged_in && $props.email,
                disabled: $setup.store.loading,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_14), [
                [_vModelText, $setup.store.billing_fields.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: $setup.trans('address'),
                disabled: $setup.store.loading,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.store.billing_fields.address) = $event))
              }, null, 8 /* PROPS */, _hoisted_17), [
                [_vModelText, $setup.store.billing_fields.address]
              ])
            ])
          ]),
          ($props.show_company)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('company'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.store.billing_fields.company) = $event))
                  }, null, 8 /* PROPS */, _hoisted_20), [
                    [_vModelText, $setup.store.billing_fields.company]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_country)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    placeholder: $setup.trans('country'),
                    loading: $setup.select_loading,
                    modelValue: $setup.store.billing_fields.country,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.store.billing_fields.country) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (name, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: key,
                          label: name,
                          value: key
                        }, null, 8 /* PROPS */, ["label", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["placeholder", "loading", "modelValue"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_county)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('county'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.store.billing_fields.state) = $event))
                  }, null, 8 /* PROPS */, _hoisted_25), [
                    [_vModelText, $setup.store.billing_fields.state]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_city)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('city'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.store.billing_fields.city) = $event))
                  }, null, 8 /* PROPS */, _hoisted_28), [
                    [_vModelText, $setup.store.billing_fields.city]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_phone_no)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('phone_no'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.store.billing_fields.phone) = $event))
                  }, null, 8 /* PROPS */, _hoisted_31), [
                    [_vModelText, $setup.store.billing_fields.phone]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_postal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('postal_code'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.store.billing_fields.zip) = $event))
                  }, null, 8 /* PROPS */, _hoisted_34), [
                    [_vModelText, $setup.store.billing_fields.zip]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($props.show_tax)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: $setup.trans('tax_code'),
                    disabled: $setup.store.loading,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.store.billing_fields.tax) = $event))
                  }, null, 8 /* PROPS */, _hoisted_37), [
                    [_vModelText, $setup.store.billing_fields.tax]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}